export const springDelay = (delay: number) => (
	props: React.CSSProperties
) => () => async (next: (props: React.CSSProperties) => Promise<void>) => {
	await new Promise((resolve) => setTimeout(resolve, delay));
	await next(props);
};
